import React from "react";
import { Stack } from "@chakra-ui/core";
import Head from "next/head";
import { useTranslation } from "~/i18n/hooks";
import { i18n } from "next-i18next";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const TermsAndConditionsRoute: React.FC = () => {
  const t = useTranslation();

  return (
    <Stack paddingX="4rem" marginTop="2rem">
      <Head>
        <title>{t("termsAndConditions.title")}</title>
        <meta
          content={t("termsAndConditions.description")}
          name="description"
        />
        <meta content={t("termsAndConditions.keywords")} name="keywords" />
        <link
          href={`${process.env.URL}/terminos-y-condiciones`}
          hrefLang="x-default"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/terminos-y-condiciones`}
          hrefLang="es"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/pt/termos-e-condições`}
          hrefLang="pt"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/en/terms-and-conditions`}
          hrefLang="en"
          rel="alternate"
        />
        <meta content={t("termsAndConditions.title")} property="og:title" />
        <meta
          content={t("termsAndConditions.description")}
          property="og:description"
        />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="og:image:url"
        />
        <meta content={t("termsAndConditions.title")} name="twitter:title" />
        <meta
          content={t("termsAndConditions.description")}
          name="twitter:description"
        />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="twitter:image"
        />
        <meta
          name="facebook-domain-verification"
          content="zkpe1pbv54w2vb37xfieodiezyc606"
        />
      </Head>
      <p className="c19">
        <span className="c1 header">
          T&eacute;rminos y Condiciones de Uso PENCY
        </span>
      </p>
      <p className="c12" style={{ marginTop: "1rem" }}>
        <span className="c2">Fecha de actualización </span>
        <span>29/07/2022</span>
        <sup>
          <a href="#cmnt1" id="cmnt_ref1"></a>
        </sup>
      </p>
      <p className="c12">
        <span className="c14">
          Estos T&eacute;rminos y Condiciones de Uso de la Plataforma Pency
          regulan el uso del sitio web [URL PENCY] y cualquier otro sitio web,
          plataforma o aplicaci&oacute;n operada por Pency
          (&ldquo;Plataforma&rdquo;) y los servicios disponibles en la
          Plataforma (&quot;Servicios&quot;).
        </span>
      </p>
      <p className="c7">
        <span className="c14">
          La Plataforma es operada en Argentina por TAP BILLETERA S.A., una
          entidad legal con sede en Maip&uacute; 1, Piso 22, Ciudad
          Aut&oacute;noma de Buenos Aires, Argentina, CUIT 30-71662753-1,
          (&ldquo;Pency&rdquo; o &ldquo;Nosotros&rdquo;).
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Al aceptar los presentes T&eacute;rminos y Condiciones de Uso los
          usuarios aseguran haber le&iacute;do, comprendido y aceptado todas las
          condiciones establecidas aqu&iacute; y en los dem&aacute;s documentos
          incorporados por referencia (colectivamente, &ldquo;Terminos&rdquo;),
          ya que las reglas, obligaciones y derechos previstos son vinculantes
          para las partes y son v&aacute;lidos para todos los usuarios de la
          Plataforma (&ldquo;Usuario&rdquo;).
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Los servicios ofrecidos pueden variar y, a veces, aplicar
          t&eacute;rminos adicionales. Al utilizar un Servicio en particular,
          usted estar&aacute; sujeto a las pautas, t&eacute;rminos y condiciones
          aplicables a ese Servicio. A menos que se indique lo contrario,
          cualquier caracter&iacute;stica nueva que aumente o mejore los
          Servicios actualmente disponibles, incluidas las nuevas versiones,
          estar&aacute; sujeta autom&aacute;ticamente a los T&eacute;rminos.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          En caso de no estar de acuerdo con los T&eacute;rminos, le pedimos que
          no utilice la Plataforma, ni se registre ni env&iacute;e datos, ya
          sean personales o de otro tipo.
        </span>
      </p>
      <p className="c0">
        <span className="c15">
          Durante el uso de la Plataforma, Pency y/o nuestros socios
          (&quot;Socios&quot;) recopilar&aacute;n y procesar&aacute;n ciertos
          datos personales conforme a nuestra&nbsp;
        </span>
        {/* Se tiene que cambiar la url - PROD_CHANGE */}
        <a
          style={{ color: "#0e79d1" }}
          href="https://web.pency.app/politica-de-privacidad"
          className="c8"
        >
          Pol&iacute;tica de Privacidad
        </a>
        <sup>
          <a href="#cmnt2" id="cmnt_ref2">
            [b]
          </a>
        </sup>
        <span className="c3">.</span>
      </p>
      <p className="c11">
        <span className="c4">
          1. REGISTRO DE USUARIO, CONTRASE&Ntilde;A Y SEGURIDAD
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El uso de la Plataforma solo est&aacute; disponible para las personas
          f&iacute;sicas o jur&iacute;dicas que tengan capacidad legal para
          contratar los Servicios y para que se les asigne
          autom&aacute;ticamente la condici&oacute;n de Usuario, e implica la
          aceptaci&oacute;n, en su totalidad y sin reservas, de todas las
          disposiciones incluidas en los T&eacute;rminos en la versi&oacute;n
          vigente en el momento del acceso a la Plataforma.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Al registrarse en la Plataforma, el Usuario podr&aacute; utilizar los
          servicios prestados por Pency declarando, por tanto, haber
          le&iacute;do, comprendido y aceptado los respectivos t&eacute;rminos
          de uso de cada uno de estos servicios, los cuales pasan a formar parte
          integral de estos T&eacute;rminos cuando se realiza el Registro.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          La contrase&ntilde;a del Usuario debe mantenerse confidencial y no
          debe ser compartida a terceros, ya que las actividades que se realicen
          en la Plataforma utilizando la contrase&ntilde;a ser&aacute;n siempre
          responsabilidad exclusiva del Usuario. Ni Pency ni ninguno de sus
          empleados o agentes le solicitar&aacute;n, por ning&uacute;n medio,
          f&iacute;sico o electr&oacute;nico, que informe o comparta su
          contrase&ntilde;a. El Usuario se compromete a informar a Pency de
          forma inmediata sobre cualquier acceso no autorizado por parte de
          terceros a su cuenta de Usuario.
        </span>
      </p>
      <p className="c11">
        <span className="c4">2. OBLIGACIONES DE REGISTRO DE USUARIO</span>
      </p>
      <p className="c0">
        <span className="c3">
          Al enviar informaci&oacute;n a Pency, el Usuario manifiesta y
          garantiza que toda la informaci&oacute;n proporcionada por cualquier
          medio es exacta, verdadera, completa y respeta la legislaci&oacute;n
          vigente, asumiendo la responsabilidad, de manera &uacute;nica,
          exclusiva e integral, frente a Pency y terceros respecto a dicha
          informaci&oacute;n.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Pency puede, a su exclusivo criterio, tomar medidas para confirmar la
          exactitud, precisi&oacute;n, veracidad, integridad y legalidad de la
          informaci&oacute;n que nos proporcione. Es posible que se le solicite
          al Usuario que env&iacute;e documentos adicionales. Tambi&eacute;n
          podr&aacute; Pency consultar bases de datos p&uacute;blicas o privadas
          para verificar la informaci&oacute;n que proporcione.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Si el Usuario proporciona informaci&oacute;n falsa, incorrecta,
          desactualizada o incompleta, o si Pency tiene motivos para sospechar
          que la informaci&oacute;n del Usuario es falsa, incorrecta,
          desactualizada o incompleta, as&iacute; como si el Usuario no
          est&aacute; de acuerdo con los T&eacute;rminos o con cualquier
          informaci&oacute;n disponible en la Plataforma, Pency tendr&aacute;
          derecho a suspender y/o eliminar el acceso del Usuario a los
          Servicios, sin previo aviso, as&iacute; como a rechazar cualquier
          nuevo acceso a uno o m&aacute;s Servicios por parte del Usuario, sin
          el pago de ninguna multa y/o indemnizaci&oacute;n.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          PENCY, COMO OPERADORA DE DATOS, NO SE HACE RESPONSABLE DE LA
          CORRECCI&Oacute;N DE LOS DATOS PERSONALES INGRESADOS POR SUS USUARIOS.
          LOS USUARIOS GARANTIZAN Y RESPONDEN, EN CUALQUIER CASO, CIVIL Y
          PENALMENTE, DE LA VERDAD, EXACTITUD Y AUTENTICIDAD DE LOS DATOS
          PERSONALES REGISTRADOS.
        </span>
      </p>
      <p className="c11">
        <span className="c4">
          3. DESCRIPCI&Oacute;N DE SERVICIOS: PRECIO, PAGO Y REEMBOLSO
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Pency no es un proveedor de ning&uacute;n producto o servicio
          anunciado por los Usuarios. Pency es un proveedor de servicios de
          espacio virtual consistente en la oferta de una tienda virtual en
          internet que brinda espacios para que los Usuarios publiciten y pongan
          a la venta sus propios productos y servicios para que cualquier
          interesado pueda adquirirlos, sin ning&uacute;n tipo de
          intermediaci&oacute;n de Pency en la relaci&oacute;n entre el Usuario
          y sus clientes.
        </span>
      </p>
      <p className="c0">
        <span className="c15">
          Una vez registrado en la Plataforma, el Usuario puede optar entre
          utilizar el Plan Gratuito o el Plan Comercial (los &ldquo;
        </span>
        <span className="c13">
          <a
            className="c6"
            href="https://www.google.com/url?q=https://web.pency.app/planes&amp;sa=D&amp;source=editors&amp;ust=1658470331063685&amp;usg=AOvVaw02Kq1tT2S6CXMCy6mM_6vY"
          >
            Planes disponibles
          </a>
        </span>
        <span className="c3">
          &rdquo;), los cuales ostentan diferentes caracter&iacute;sticas. El
          Usuario podr&aacute; adherirse al plan mensual, trimestral o anual,
          por los montos anunciados y detallados por Pency en el momento de la
          contrataci&oacute;n. Los precios cobrados est&aacute;n sujetos a
          cambios en cualquier momento a discreci&oacute;n exclusiva de Pency.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Independientemente del plan elegido, se pondr&aacute; a
          disposici&oacute;n del Usuario, entre otras caracter&iacute;sticas:
        </span>
      </p>
      <ul className="c5 lst-kix_list_1-0 start">
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            Tienda Virtual: una tienda virtual con capacidad para poner a
            disposici&oacute;n del p&uacute;blico en general, a trav&eacute;s de
            internet, la venta de productos o servicios del Usuario, sin
            necesidad de contratar un servicio de hosting (&quot;Tienda&quot;),
            siempre que el contenido vendido en la Tienda cumpla con los
            T&eacute;rminos y/o la legislaci&oacute;n aplicable.
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            Panel de Administraci&oacute;n: Al crear la Tienda, el Usuario
            podr&aacute; administrar sus productos o servicios, pudiendo subir y
            editar fotos, descripciones y precios a trav&eacute;s de un panel de
            administraci&oacute;n disponible en la Plataforma para tal efecto.
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            Sistema &quot;Carrito de Compras&quot;: La Tienda tendr&aacute; la
            posibilidad de contar con un sistema que permita a los visitantes
            seleccionar los productos de su inter&eacute;s, detallando todos los
            pasos necesarios para completar la compra.
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            Integraciones: Posibilidad de integraci&oacute;n con soluciones de
            log&iacute;stica y transporte, m&eacute;todos de pago y otras
            aplicaciones puestas a disposici&oacute;n por Pency o por terceros,
            si es de inter&eacute;s para el Usuario.
          </span>
        </li>
      </ul>
      <p className="c0">
        <span className="c3">
          El Usuario deber&aacute; pagar los Servicios prestados dentro de los
          t&eacute;rminos y en la forma que se determine en el momento de la
          contrataci&oacute;n. Si hay un retraso en el pago de los Servicios,
          Pency tendr&aacute; derecho, a su sola discreci&oacute;n, a suspender
          o cancelar el Registro de Usuario, as&iacute; como a emprender
          acciones legales para recibir los montos pendientes.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Si el Usuario dispone el pago de cantidades pendientes, Pency se
          reserva el derecho de descontar cualquier tiempo de uso prestado como
          anticipo, del nuevo plazo contratado. En este caso, se
          reactivar&aacute; el Registro de Usuario en un plazo razonable de
          funcionamiento.
        </span>
      </p>
      <p className="c0" id="h.gjdgxs">
        <span className="c3">
          El Usuario podr&aacute; solicitar la cancelaci&oacute;n de los
          Servicios ofrecidos por Pency en cualquier momento. En caso de
          requerir la cancelaci&oacute;n dentro de los 10 (diez) d&iacute;as
          corridos desde el momento del pago, se le rembolsara al Usuario el 80%
          del monto abonado. Una vez cumplido dicho plazo, el Usuario no
          tendr&aacute; derecho a ning&uacute;n tipo de reembolso o
          devoluci&oacute;n del monto pagado si opta por no utilizar los
          Servicios en su totalidad o en parte o en caso de cancelaci&oacute;n,
          por cualquier motivo. &nbsp;En caso de querer el Usuario solicitar un
          cambio de plan, aplicar&aacute; la misma regla.
        </span>
      </p>
      <p className="c11">
        <span className="c4">4. OBLIGACIONES GENERALES DEL USUARIO</span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario se compromete a cumplir con la legislaci&oacute;n vigente
          para la oferta de productos y servicios en la Tienda y garantizar la
          privacidad de sus clientes, incluyendo, pero no limitado a las Leyes
          No. 24.240 (Defensa del Consumidor), 22.802 (Lealtad Comercial),
          25.226 (Datos Personales), 27.442 (Defensa de la Competencia) y el
          C&oacute;digo Civil y Comercial de la Naci&oacute;n, y debe hacer que
          la siguiente informaci&oacute;n est&eacute; disponible en un lugar
          destacado y f&aacute;cil de ver:
        </span>
      </p>
      <ul className="c5 lst-kix_list_3-0 start">
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            Raz&oacute;n social o DNI (en caso de persona humana) y CUIT;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            direcci&oacute;n f&iacute;sica y electr&oacute;nica, y otra
            informaci&oacute;n necesaria para su ubicaci&oacute;n y contacto;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            caracter&iacute;sticas esenciales del producto o servicio, incluidos
            los riesgos para la salud y la seguridad de los consumidores;
            discriminaci&oacute;n de precios de cualquier gasto adicional o
            incidental, como entrega o seguro;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            t&eacute;rminos y condiciones completos de la oferta, incluidos los
            t&eacute;rminos de pago, disponibilidad, forma y plazo de
            ejecuci&oacute;n del servicio o entrega o disponibilidad del
            producto;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            informaci&oacute;n clara y visible sobre cualquier
            restricci&oacute;n en el disfrute de la oferta;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            informaci&oacute;n clara y visible sobre la recopilaci&oacute;n y
            protecci&oacute;n de datos personales de los visitantes y sus
            registros de acceso a la Tienda, teniendo en cuenta que los datos se
            compartir&aacute;n y procesar&aacute;n en servidores de Pency o de
            quien Pency designe a tal fin;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            Documento Nacional de Identidad y la informaci&oacute;n de contacto
            de la persona designada por el Usuario para actuar como canal de
            comunicaci&oacute;n entre el Usuario, los visitantes y la
            Direcci&oacute;n Nacional de Protecci&oacute;n de Datos Personales
            (&quot;Supervisor&quot;), debiendo la identidad del Supervisor y la
            informaci&oacute;n de contacto ser divulgadas p&uacute;blicamente,
            de forma clara y objetiva, en la Tienda del Usuario;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            informaci&oacute;n clara y visible sobre los medios adecuados y
            efectivos para que el consumidor ejerza el derecho al
            arrepentimiento.
          </span>
        </li>
      </ul>
      <p className="c0">
        <span className="c3">
          Cuando no est&eacute; impedido por la Ley de Protecci&oacute;n de
          Datos Personales, el Usuario se compromete a obtener el consentimiento
          libre, informado e inequ&iacute;voco de los visitantes de la Tienda
          para que sus datos personales y registros de acceso a la Tienda sean
          cedidos y procesados &#8203;&#8203;por Pency y sus socios
          exclusivamente para la prestaci&oacute;n de servicios por parte del
          Usuario.
        </span>
      </p>
      <p className="c11">
        <span className="c4">5. CONDUCTA PROHIBIDA</span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario tiene PROHIBIDO utilizar los Servicios para cargar,
          anunciar, enviar, mostrar o poner a disposici&oacute;n cualquier
          contenido, producto o servicio:
        </span>
      </p>
      <ul className="c5 lst-kix_list_4-0 start">
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            que sea ilegal o que no cuente con la debida autorizaci&oacute;n
            espec&iacute;fica de los organismos reguladores competentes,
            incluyendo, pero no limitado a, que sea ofensivo para el honor, que
            invada la privacidad de terceros, que sea amenazante, vulgar,
            obsceno, prejuicioso, racista u objetable de cualquier forma;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            que viole cualquier patente, marca comercial, secreto comercial,
            derechos de autor, derechos de propiedad intelectual o cualquier
            otro derecho de un tercero;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            que constituya publicidad ilegal o desleal;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            sin tener derecho a hacerlo de acuerdo con la ley, en virtud de un
            contrato o relaci&oacute;n de confianza, incluidos, entre otros, los
            acuerdos de confidencialidad.
          </span>
        </li>
      </ul>
      <p className="c0">
        <span className="c3">Queda PROHIBIDO al Usuario, adem&aacute;s:</span>
      </p>
      <ul className="c5 lst-kix_list_5-0 start">
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            presentarse con un nombre id&eacute;ntico o que tenga alg&uacute;n
            parecido con los nombres y marcas de terceros o asumir la
            personalidad o identidad de otra persona, humana o jur&iacute;dica,
            incluyendo, pero no limitado a: un representante de Pency, o
            declarar o presentarse falsamente como miembro de una entidad;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            comunicar que los productos o servicios que ofrece est&aacute;n
            patrocinados, promocionados, producidos, ofrecidos y/o vendidos por
            Pency;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            interferir o interrumpir los Servicios, redes o servidores
            conectados a los Servicios, obtener o intentar obtener acceso no
            autorizado a otros sistemas inform&aacute;ticos o redes conectadas a
            los Servicios, o desobedecer cualquier regla, procedimiento,
            pol&iacute;tica o regulaci&oacute;n de redes o sistemas conectados a
            los Servicios, incluido el uso de dispositivos, software u otras
            rutinas similares;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            violar, intencional o involuntariamente, cualquier
            legislaci&oacute;n municipal, provincial, federal o internacional
            que est&eacute; integrada en el ordenamiento jur&iacute;dico
            argentino, o que, por cualquier raz&oacute;n deba aplicarse en
            Argentina;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            reproducir, duplicar, copiar, vender, revender o explotar todo o
            parte de los Servicios o su contenido sin el consentimiento expreso
            por escrito de Pency.
          </span>
        </li>
      </ul>
      <p className="c0">
        <span className="c3">
          Pency asegura respeto y cordialidad en la relaci&oacute;n con los
          Usuarios. Por esta raz&oacute;n, en cualquier interacci&oacute;n del
          Usuario y sus representantes con el equipo de Pency, no se
          tolerar&aacute; el uso de lenguaje grosero, irrespetuoso, insultante,
          discriminatorio o inapropiado. Cualquier Usuario que utilice este tipo
          de lenguaje inapropiado puede ser suspendido temporal o
          permanentemente de la Plataforma.
        </span>
      </p>
      <p className="c11">
        <span className="c4">6. ENLACES A SITIOS DE TERCEROS</span>
      </p>
      <p className="c0">
        <span className="c3">
          Para la comodidad del Usuario, proporcionamos enlaces a sitios web y
          aplicaciones de terceros, y la integraci&oacute;n con su Tienda de los
          servicios adicionales que ellos ponen a disposici&oacute;n queda a su
          entera discreci&oacute;n. Como dichos sitios web y aplicaciones no
          est&aacute;n bajo nuestro control, no podemos garantizar la calidad,
          precisi&oacute;n, puntualidad o seguridad de estos sitios web y
          aplicaciones.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          UN ENLACE HACIA O DESDE OTRO SITIO NO SIGNIFICA QUE HAY UNA
          CONEXI&Oacute;N ENTRE PENCY Y EL TERCERO PROPIETARIO DE DICHO SITIO O
          QUE HAY UNA APROBACI&Oacute;N DEL SITIO DE TERCEROS O CUALQUIER
          PRODUCTO O SERVICIO DESCRITO O VENDIDO EN EL MISMO.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          EL ACCESO Y EL USO DE CUALQUIER OTRO SITIO DE TERCEROS A TRAV&Eacute;S
          DE ENLACES A DICHO SITIO O DESDE DICHO SITIO ES BAJO SU PROPIO RIESGO,
          POR LO QUE LE RECOMENDAMOS ENCARECIDAMENTE QUE LEA LOS T&Eacute;RMINOS
          Y CONDICIONES DE USO, AS&Iacute; COMO LA POL&Iacute;TICA DE ESTOS
          SITIOS. PODEMOS DESHABILITAR UN ENLACE EN CUALQUIER MOMENTO Y
          ELIMINAREMOS CUALQUIER ENLACE DE ESTE SITIO A SOLICITUD DEL
          PROPIETARIO DEL SITIO DE TERCEROS.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          USTED RECONOCE QUE PUEDEN APLICARSE DIFERENTES T&Eacute;RMINOS DE USO
          Y POL&Iacute;TICA DE PRIVACIDAD AL USO DE SITIOS DE TERCEROS. PPENCY
          NO GARANTIZA ESTOS SERVICIOS Y CONTENIDOS DE TERCEROS Y EN
          NING&Uacute;N CASO SEREMOS RESPONSABLES DE NING&Uacute;N PRODUCTO O
          SERVICIO DE DICHOS TERCEROS.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          PENCY PUEDE SUSPENDER O ELIMINAR LOS ENLACES A SITIOS Y APLICACIONES
          DE TERCEROS A SU &Uacute;NICA DISCRECI&Oacute;N SIN PREVIO AVISO.
        </span>
      </p>
      <p className="c0 c10">
        <span className="c3"></span>
      </p>
      <p className="c0">
        <span className="c17 c15">7.</span>
        <span className="c17">
          &nbsp;CONDICIONES DE PAGO DE LA CUOTA Y/O DE LAS PRESTACIONES
          ADICIONALES
        </span>
      </p>
      <p className="c7">
        <span className="c3">
          Pency puede cobrar una determinada tarifa por el uso de algunas de sus
          funciones, en cuyo caso, al registrarse en una cuenta de Pency, usted
          acepta pagar a Pency la tarifa aplicable a la funci&oacute;n, plan o
          nivel de cuenta elegido por usted al registrarse. Pency se reserva el
          derecho de actualizar o cambiar la tarifa, la estructura de tarifas,
          las caracter&iacute;sticas o los detalles del plan en cualquier
          momento con previo aviso. En caso de actualizaci&oacute;n,
          reducci&oacute;n o cambio de las caracter&iacute;sticas del plan
          seleccionado, del plan o del nivel, la tarifa actualizada se
          cobrar&aacute; en el siguiente ciclo de facturaci&oacute;n.
        </span>
      </p>
      <p className="c0">
        <span className="c15 c17">8. </span>
        <span className="c4">CONDICIONES DE PAGO EN L&Iacute;NEA</span>
      </p>
      <p className="c7">
        <span className="c3">
          Pency podr&iacute;a ofrecer una funci&oacute;n para aceptar pagos en
          l&iacute;nea. La disponibilidad del M&eacute;todo de Pago var&iacute;a
          seg&uacute;n la geograf&iacute;a. Dependiendo de su ubicaci&oacute;n,
          es posible que no pueda utilizar uno o varios de los M&eacute;todos de
          Pago. Los M&eacute;todos de Pago poder provenir de varios proveedores
          externos, y cada proveedor controla los t&eacute;rminos que se aplican
          a su M&eacute;todo de Pago. Por lo tanto, usted acepta que, para
          utilizar la funci&oacute;n de pagos en l&iacute;nea, deber&aacute;,
          adem&aacute;s de estos T&eacute;rminos y Condiciones, aceptar los
          t&eacute;rminos y condiciones especificados por el correspondiente
          proveedor de M&eacute;todos de Pago. Pency no proporciona ni
          est&aacute; involucrado directa o indirectamente en el proceso de pago
          en l&iacute;nea y, como tal, no tiene ning&uacute;n tipo de control o
          participaci&oacute;n sobre dichas transacciones. En consecuencia,
          Pency no ser&aacute; responsable ni asumir&aacute; responsabilidad
          alguna por las transacciones de pago en l&iacute;nea, incluyendo
          aquellas que impliquen transacciones incorrectas; fraudes, reembolsos
          o introducci&oacute;n de datos inexactos. Los t&eacute;rminos y
          condiciones aplicables a un M&eacute;todo de Pago est&aacute;n sujetos
          a cambios en cualquier momento, que ser&aacute;n notificados por el
          proveedor del M&eacute;todo de Pago de acuerdo con dichos
          t&eacute;rminos, y ser&aacute; su responsabilidad revisar
          peri&oacute;dicamente el cumplimiento de los requisitos aplicables.
        </span>
      </p>
      <p className="c11">
        <span className="c4">9. RESPONSABILIDADES DEL DROPSHIPPING</span>
      </p>
      <p className="c0">
        <span className="c3">
          Al integrar su Tienda con aplicaciones de terceros que ofrecen
          servicios de dropshipping, el Usuario se compromete a cumplir con la
          legislaci&oacute;n vigente para la oferta de productos y servicios en
          la Tienda, incluyendo, pero no limitadose a, las Leyes de Defensa del
          Consumidor, de Lealtad Comercial y el C&oacute;digo Civil y Comercial,
          brindando la siguiente informaci&oacute;n, pero no limit&aacute;ndose
          a ella, en un lugar destacado y de f&aacute;cil visualizaci&oacute;n:
          (i) indisponibilidad f&iacute;sica del producto en stock y necesidad
          de pedido; (ii) plazo de entrega y procedimiento en caso de posibles
          retrasos; (iii) tratamiento y pol&iacute;tica por productos
          defectuosos, cambios de producto, ejercicio del derecho de
          arrepentimiento, pago de flete para devolver el producto; (iv) el
          cumplimiento de las garant&iacute;as legales previstas en la Ley de
          Defensa del Consumidor; (v) car&aacute;cter vinculante de la oferta en
          los t&eacute;rminos de la Ley de Defensa del Consumidor; (vi)
          procedimiento a ser adoptado para productos importados en caso de
          imposici&oacute;n de restricciones aduaneras; y (vii) impuestos que
          gravan los productos importados cuyo pago es responsabilidad exclusiva
          de los consumidores.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario ser&aacute; el &uacute;nico responsable de la
          informaci&oacute;n facilitada en la Tienda y del cumplimiento de las
          obligaciones derivadas de la misma, as&iacute; como de los productos
          comercializados, incluyendo, sin car&aacute;cter limitativo, su
          calidad, legitimidad, funcionamiento, titularidad, permisibilidad,
          entrega y garant&iacute;a. Sin perjuicio de los dem&aacute;s derechos
          previstos en la legislaci&oacute;n, Pency tiene asegurado el derecho a
          interponer un recurso y a quedar indemne frente a todas y cada una de
          las p&eacute;rdidas derivadas de o relacionadas con las actividades
          del Usuario en la Plataforma.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario ser&aacute; el &uacute;nico responsable de todas y cada una
          de las obligaciones fiscales que recaigan sobre sus actividades.
          Cuando la obligaci&oacute;n de pagar alg&uacute;n impuesto recaiga
          sobre los consumidores (como en el caso de los productos importados),
          el Usuario deber&aacute; proporcionar la informaci&oacute;n en un
          lugar destacado y f&aacute;cilmente visible.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Como es de conocimiento del Usuario, PENCY NO FORMA PARTE DEL NEGOCIO
          DE LA VENTA CON DROPSHIPPING, NO PARTICIPA EN LA LOG&Iacute;STICA PARA
          EL ENV&Iacute;O DE MERCADER&Iacute;AS, NI TIENE NINGUNA INFERENCIA EN
          LOS ACTOS REALIZADOS EN LA PRESTACI&Oacute;N DE SERVICIOS RELACIONADOS
          A DROPSHIPPING. POR LO TANTO, PENCY NO SER&Aacute; RESPONSABLE DE
          NING&Uacute;N DA&Ntilde;O RESULTANTE Y/O LUCRO CESANTE QUE EL USUARIO
          PUEDA SUFRIR COMO CONSECUENCIA DE LOS DA&Ntilde;OS Y/O ACTOS DE
          TERCEROS. LA RESPONSABILIDAD DE PENCY EST&Aacute; LIMITADA Y
          RESTRINGIDA A LA PROVISI&Oacute;N DE INTEGRACIONES CON APLICACIONES DE
          DROPSHIPPING A LOS USUARIOS DE LA PLATAFORMA. ES OPCI&Oacute;N DEL
          USUARIO EL USO O NO DE DICHOS SERVICIOS, SUJETO A LAS LIMITACIONES Y
          T&Eacute;RMINOS DE REFERENCIA.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario est&aacute; obligado a cooperar con Pency, en caso de
          cualquier reclamo de terceros que involucre productos provistos en el
          modelo de dropshipping, para que se le informe de todos los datos
          pertenecientes al producto comprado, incluyendo, pero no limitado a,
          especificaciones del producto, fecha de adquisici&oacute;n, fecha de
          env&iacute;o y recepci&oacute;n.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Asimismo, ante cualquier reclamo de terceros, ya sea administrativo o
          mediante la interposici&oacute;n de una demanda contra Pency por
          hechos que sean responsabilidad del Usuario y/o de la
          aplicaci&oacute;n utilizada en la operaci&oacute;n de Dropshipping, el
          Usuario se compromete a informar a la respectiva autoridad competente,
          administrativa o judicial, mediante defensa u otra
          manifestaci&oacute;n que pueda presentarse en el procedimiento
          administrativo o judicial, que Pency no tiene responsabilidad por lo
          sucedido y que aboga por la exclusi&oacute;n de Pency del conflicto de
          inmediato.
        </span>
      </p>
      <p className="c11">
        <span className="c4">10. PROPIEDAD INTELECTUAL Y LICENCIAS</span>
      </p>
      <p className="c0">
        <span className="c3">
          Todos los elementos de la Plataforma, incluida la Plataforma en
          s&iacute;, est&aacute;n protegidos por Derechos de Propiedad
          Intelectual de Pency o de terceros, incluidos, entre otros, secretos
          comerciales, derechos de autor y marcas.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Estos T&eacute;rminos o el uso de la Plataforma no le otorgan ninguna
          licencia o derecho para usar los derechos de propiedad intelectual de
          Pency o de terceros. Excepto por el uso de la Plataforma seg&uacute;n
          lo dispuesto en este documento, no utilizar&aacute; los derechos de
          propiedad intelectual contenidos en la Plataforma. Tambi&eacute;n se
          compromete a no descompilar, realizar ingenier&iacute;a inversa,
          desensamblar, desencriptar o crear trabajos derivados de o basados
          &#8203;&#8203;en la Plataforma o su contenido.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario autoriza a Pency a utilizar, publicar, reproducir y/o
          adaptar las im&aacute;genes y fotograf&iacute;as incluidas en sus
          Tiendas, su nombre comercial, marcas, frases publicitarias, logotipos,
          dise&ntilde;os, im&aacute;genes y cualquier otro signo distintivo que
          identifique al Usuario y sus productos o servicios (&quot;Marca&quot;)
          e informaci&oacute;n sobre sus productos y servicios
          (&quot;Informaci&oacute;n del producto&quot;).
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario otorga a Pency una autorizaci&oacute;n gratuita,
          irrevocable, no exclusiva, de alcance internacional e ilimitada para
          usar, publicar, reproducir y/o adaptar las im&aacute;genes,
          fotograf&iacute;as, Informaci&oacute;n de Producto y la Marca, con la
          finalidad de ser utilizadas en todos los sitios web de Pency, en redes
          sociales y/o en cualquier medio de comunicaci&oacute;n, incluyendo,
          pero no limitado a plataformas y/o cualquier otro medio digital o
          f&iacute;sico que Pency considere apropiado o en plataformas o sitios
          web con los que Pency se haya asociado para realizar publicidad y
          marketing o acciones vinculadas a los Servicios, incluida la
          posibilidad de asociaci&oacute;n con marcas y/o nombres comerciales de
          terceros.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario manifiesta y garantiza que es titular o licenciatario de
          los derechos de las im&aacute;genes y fotograf&iacute;as publicadas en
          su Tienda, de la Marca, as&iacute; como de la Informaci&oacute;n del
          Producto y que dispone de los derechos y autorizaciones necesarios
          para otorgar la autorizaci&oacute;n detallada en esta cl&aacute;usula
          siendo el &uacute;nico y exclusivo responsable de cualquier
          infracci&oacute;n de derechos de terceros o de inconsistencias o
          inexactitudes en la Informaci&oacute;n del Producto.
        </span>
      </p>
      <p className="c11">
        <span className="c4">11. CONFIDENCIALIDAD</span>
      </p>
      <p className="c0">
        <span className="c15">
          A excepci&oacute;n de los datos personales, cuya definici&oacute;n y
          reglas se describen en la&nbsp;
        </span>
        {/* Se tiene que cambiar la url - PROD_CHANGE */}
        <a
          style={{ color: "#0e79d1" }}
          href="https://web.pency.app/politica-de-privacidad"
          className="c8"
        >
          Pol&iacute;tica
        </a>
        <sup>
          <a href="#cmnt3" id="cmnt_ref3">
            [c]
          </a>
        </sup>
        <span className="c8">&nbsp;de Privacidad</span>
        <span className="c3">
          , toda la informaci&oacute;n que usted proporcione durante el uso de
          la Plataforma ser&aacute; tratada por el Usuario y por Pency como
          confidencial.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Sin embargo, no ser&aacute; confidencial la informaci&oacute;n que es
        </span>
      </p>
      <ul className="c5 lst-kix_list_6-0 start">
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            previamente conocida por ser de dominio p&uacute;blico;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            desarrollada en forma independiente por la parte receptora;
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            obtenida de terceros que no est&aacute;n sujetos al correspondiente
            deber de confidencialidad; o
          </span>
        </li>
        <li className="c0 c2 li-bullet-0">
          <span className="c3">
            que se haga p&uacute;blica sin que se hayan violado las obligaciones
            de confidencialidad asumidas en este documento.
          </span>
        </li>
      </ul>
      <p className="c0">
        <span className="c3">
          La obligaci&oacute;n de confidencialidad aqu&iacute; establecida
          permanecer&aacute; vigente durante todo el per&iacute;odo en el que la
          informaci&oacute;n se considere de car&aacute;cter confidencial.
        </span>
      </p>
      <p className="c11">
        <span className="c4">12. GARANT&Iacute;AS Y RESPONSABILIDADES</span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario reconoce y acepta que Pency no participa ni interviene en
          el contenido de la Tienda publicado por el Usuario. Por tanto, el
          Usuario reconoce, garantiza y acepta que el contenido publicado en la
          Plataforma y en la Tienda por el Usuario, es de su &uacute;nica y
          exclusiva responsabilidad y cuenta con la autorizaci&oacute;n,
          licencia y/o permisos necesarios para su publicaci&oacute;n y/o uso de
          conformidad con la ley aplicable.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario reconoce y acepta que, al publicar alg&uacute;n contenido
          en su Tienda, otros usuarios de Internet pueden tener acceso a lo que
          fue publicado, autorizando, en adelante, a Pency a mostrar dichos
          contenidos en Internet, almacenarlos en su base de datos y
          transferirlos a sus Socios, eximiendo a Pency de cualquier reclamo y/o
          perjuicio relacionado con el uso del contenido publicado.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario indemnizar&aacute; a Pency, sus directores,
          administradores, colaboradores, representantes y empleados por
          cualquier demanda promovida por terceros derivada de sus actividades
          en las Tiendas, por su incumplimiento de los T&eacute;rminos, o por la
          violaci&oacute;n de cualquier ley o derechos de terceros, incluidos
          los honorarios de los abogados.
        </span>
      </p>
      <p className="c11">
        <span className="c4">
          13. INFORMACI&Oacute;N, DISPONIBILIDAD Y TECNOLOG&Iacute;A
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Nuestro objetivo es garantizar que cualquier informaci&oacute;n
          disponible en la Plataforma sea precisa y completa. Sin embargo, toda
          la informaci&oacute;n disponible en la Plataforma se proporciona solo
          con fines informativos y le recomendamos que verifique la
          precisi&oacute;n de cualquier informaci&oacute;n antes de confiar en
          ella. No tenemos ni pretendemos tener ninguna obligaci&oacute;n,
          pudiendo Pency, a su sola discreci&oacute;n, realizar los cambios
          necesarios para actualizar o corregir cualquier informaci&oacute;n en
          la Plataforma.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Usted es consciente de que el uso de la Plataforma puede no ser 100%
          seguro, con la posibilidad de que la informaci&oacute;n
          enviada/recibida pueda ser interceptada por personas no autorizadas,
          incluso si Pency utiliza los m&aacute;s altos est&aacute;ndares de
          seguridad de la informaci&oacute;n, no siendo Pency responsable de
          fallas en la seguridad de las comunicaciones que excedan los
          est&aacute;ndares esperados y requeridos por las leyes aplicables y no
          asumiendo responsabilidad alguna por el mal uso de su
          informaci&oacute;n por parte de terceros bajo estas condiciones.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Pency no garantiza, bajo ning&uacute;n concepto, que la Plataforma
          est&eacute; libre de posibles fallos, interrupciones, virus y otros
          factores tecnol&oacute;gicos fuera del control de la Plataforma. Por
          esta raz&oacute;n, pency no se hace responsable de la p&eacute;rdida
          de contenido almacenado o fallas.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          la plataforma es proporcionada en las condiciones necesarias para su
          operaci&oacute;n, sin garant&iacute;a de ning&uacute;n tipo, ya sea
          expresa o impl&iacute;cita, en relaci&oacute;n con las
          caracter&iacute;sticas actuales o futuras, incluyendo, pero no
          limitado a, garant&iacute;as de responsabilidad, rendimiento, esfuerzo
          o garant&iacute;as de aptitud para un prop&oacute;sito en particular.
          pency no garantiza que el rendimiento de la plataforma sea
          ininterrumpido o libre de errores. pency no ofrece garant&iacute;as
          con respecto a ning&uacute;n resultado que se pueda obtener utilizando
          la plataforma.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          pency siempre est&aacute; trabajando para mejorar los servicios, los
          cuales pueden cambiar, ser suspendidos o discontinuados sin previo
          aviso.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          en ning&uacute;n caso pency o sus directores, asesores, afiliadas,
          controlantes o subsidiarias y/o socios ser&aacute;n responsables de
          ning&uacute;n da&ntilde;o directo o indirecto que surja o de alguna
          manera relacionado con su acceso o uso de la plataforma.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          el usuario reconoce y acepta que, al elegir acceder al c&oacute;digo
          fuente de la tienda con el fin de hacer personalizaciones no
          disponibles por el panel administrador de pency, el usuario
          tendr&aacute; la responsabilidad total de cualquiera y todas las
          modificaciones que realice. en ese caso, usted acepta que no
          recibir&aacute; actualizaciones de la plataforma ni soporte para
          aplicarlas. pency no es responsable de los servicios y valores
          proporcionados por terceros, socios o no, contratados por el usuario
          para realizar tales personalizaciones, ni de los servicios de
          mantenimiento necesarios.
        </span>
      </p>
      <p className="c11">
        <span className="c4">14. DISPOSICIONES GENERALES</span>
      </p>
      <p className="c0">
        <span className="c3">
          La nulidad, anulaci&oacute;n o inaplicabilidad de cualquier
          cl&aacute;usula o secci&oacute;n de los T&eacute;rminos en forma total
          o parcial no afectar&aacute; a las dem&aacute;s cl&aacute;usulas, que
          permanecer&aacute;n intactas y plenamente v&aacute;lidas y con plenos
          efectos a todos los efectos legales siendo cada clausula o
          secci&oacute;n independiente.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Los T&eacute;rminos obligan a Pency y al Usuario, sus herederos y
          sucesores en cualquier capacidad.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          Los T&eacute;rminos y el uso de la Plataforma no establecen
          relaci&oacute;n laboral, mandato, sociedad, asociaci&oacute;n,
          agencia, representaci&oacute;n, consorcio, joint venture, franquicia o
          responsabilidad solidaria o subsidiaria entre Pency y los Usuarios,
          quienes son personas independientes y aut&oacute;nomas, para todos los
          efectos legales, ni confiere poderes de representaci&oacute;n mutua en
          ning&uacute;n negocio legal.
        </span>
      </p>
      <p className="c0">
        <span className="c3">
          El Usuario es consciente de que Pency no forma parte de ninguna
          relaci&oacute;n comercial que el Usuario lleve a cabo con sus
          clientes, ni tiene ning&uacute;n control sobre la existencia, calidad,
          seguridad o legalidad de los productos o servicios publicitados por el
          Usuario.
        </span>
      </p>
      <p className="c11">
        <span className="c4">
          15. LEGISLACI&Oacute;N Y RESOLUCI&Oacute;N DE CONFLICTOS
        </span>
      </p>
      <p className="c7">
        <span className="c3">
          Estos T&eacute;rminos se interpretar&aacute;n de acuerdo con la ley
          argentina.
        </span>
      </p>
      <p className="c7">
        <span className="c15">
          En caso de que el Usuario tenga alg&uacute;n tipo de problema al
          momento de ingresar, operar, realizar modificaciones o cualquier otro
          tipo de inconveniente en la Plataforma, el mismo tendr&aacute; a
          disposici&oacute;n un equipo que podr&aacute; brindarle soporte para
          intentar resolver el inconveniente. A estos fines se le proporciona al
          Usuario el siguiente e-mail de contacto:{" "}
        </span>
        <span className="c13">
          <a className="c6" href="mailto:centrodeayudapency@gmail.com">
            centrodeayudapency@gmail.com
          </a>
        </span>
        <span className="c3">
          . Tambi&eacute;n se le proporciona el siguiente n&uacute;mero
          telef&oacute;nico para contactarse v&iacute;a &ldquo;WhatsApp&rdquo;:
          +54 9117369-4572
        </span>
      </p>
      <p className="c7">
        <span className="c3">
          Si luego de intentar resolver el asunto con nosotros, opta por
          demandarnos ante un tribunal por cualquier disputa, la demanda debe
          presentarse en los Tribunales Ordinarios de la Ciudad Aut&oacute;noma
          de Bs As.
        </span>
      </p>
      <p className="c11">
        <span className="c4">16. ACTUALIZACIONES DE T&Eacute;RMINOS</span>
      </p>
      <p className="c11">
        <span className="c15">
          Con el fin de mejorar los servicios prestados, los T&eacute;rminos
          pueden ser actualizados por Pency en cualquier momento. Si hay un
          cambio significativo, los nuevos T&eacute;rminos entrar&aacute;n en
          vigencia 10 (diez) d&iacute;as corridos despu&eacute;s de su
          publicaci&oacute;n. En caso de no estar de acuerdo con los cambios
          incorporados, dentro de los 5 (cinco) d&iacute;as corridos a partir de
          la publicaci&oacute;n de la nueva versi&oacute;n, el Usuario debe
          enviar un correo electr&oacute;nico a&nbsp;
        </span>
        <span className="c13">
          <a className="c6" href="mailto:centrodeayudapency@gmail.com">
            centrodeayudapency@gmail.com
          </a>
        </span>
        <span className="c3">
          &nbsp;dando aviso de ello o contactarse al n&uacute;mero +54
          9117369-4572 v&iacute;a &ldquo;WhatsApp&rdquo;. En este caso, la
          relaci&oacute;n contractual dejar&aacute; de existir, mientras no
          existan importes pendientes. De no existir manifestaci&oacute;n dentro
          del plazo estipulado, se entender&aacute; que el Usuario ha aceptado
          las nuevas condiciones y el contrato ser&aacute; vinculante para ambas
          partes.
        </span>
      </p>
      <p className="c11">
        <span className="c4">17. CANCELACI&Oacute;N DE SERVICIOS</span>
      </p>
      <p className="c7">
        <span className="c15">
          Para cancelar el Servicio obtenido por Pency, el Usuario debe
          contactarse con el equipo de soporte quien le indicar&aacute; paso a
          paso las instrucciones para dar de baja el servicio. El Usuario puede
          contactarse con el equipo tanto v&iacute;a e-mail{" "}
        </span>
        <span className="c13">
          <a className="c6" href="mailto:centrodeayudapency@gmail.com">
            centrodeayudapency@gmail.com
          </a>
        </span>
        <span className="c3">
          , como v&iacute;a telef&oacute;nica +54 9117369-4572 a trav&eacute;s
          de &ldquo;WhatsApp&rdquo;.
        </span>
      </p>
      <p className="c11">
        <span className="c4">18. ADJUNTOS</span>
      </p>
      <p className="c0">
        <span className="c3">
          Los documentos incorporados por referencia son parte integral e
          inseparable de los T&eacute;rminos, donde se detallan las
          pol&iacute;ticas y / o T&eacute;rminos y condiciones de los diferentes
          servicios que ofrece la Plataforma.
        </span>
      </p>
      <div className="c20">
        <p className="c16">
          <a href="#cmnt_ref1" id="cmnt1">
            [a]
          </a>
          <span className="c9">
            Rellenar con fecha del d&iacute;a de publicaci&oacute;n
          </span>
        </p>
      </div>
      <div className="c20">
        <p className="c16">
          <a href="#cmnt_ref2" id="cmnt2">
            [b]
          </a>
          <span className="c9">
            Generar hiperv&iacute;nculo a la plataforma de Pency
          </span>
        </p>
      </div>
      <div className="c20">
        <p className="c16">
          <a href="#cmnt_ref3" id="cmnt3">
            [c]
          </a>
          <span className="c9">
            Generar hiperv&iacute;nculo a las Pol&iacute;ticas de Privacidad
          </span>
        </p>
      </div>
    </Stack>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  // Return stores so we can build a directory
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
};

export default TermsAndConditionsRoute;
